import { useRef } from "react";
import { Box, Typography } from "@mui/material";
import { motion } from "framer-motion";
import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";

export default function PhotoManager({ photos, setPhotos }) {

  const inputRef = useRef();

  const uploadToCloudinary = async (file) => {

    const formData = new FormData();
    formData.append("file", file);
    formData.append("upload_preset", "komorotel_unsigned");

    const res = await fetch(
      "https://api.cloudinary.com/v1_1/dhwqnwnvh/image/upload",
      {
        method: "POST",
        body: formData
      }
    );

    const result = await res.json();
    return result.secure_url;
  };

  const handleUpload = async (files) => {

    const uploaded = await Promise.all(
      [...files].map((file) => uploadToCloudinary(file))
    );

    setPhotos([...photos, ...uploaded]);
  };

  const handleDelete = (photo) => {
    const newPhotos = photos.filter((p) => p !== photo);
    setPhotos(newPhotos);
  };

  // ⭐ définir photo principale
  const setAsMain = (photo) => {

    const others = photos.filter((p) => p !== photo);

    setPhotos([photo, ...others]);

  };

  return (

    <Box>

      <Typography variant="subtitle1" mb={1}>
        Photos
      </Typography>

      {/* Upload area */}

      <Box
        onClick={() => inputRef.current.click()}
        sx={{
          border: "2px dashed #d0d5dd",
          borderRadius: 3,
          p: 3,
          textAlign: "center",
          cursor: "pointer",
          background: "#fafafa",
          transition: "all 0.2s",
          "&:hover": {
            borderColor: "#6366f1",
            background: "#f9fafb"
          }
        }}
      >

        <AddPhotoAlternateIcon sx={{ fontSize: 40, color: "#6366f1" }} />

        <Typography mt={1} fontWeight={500}>
          Ajouter des photos
        </Typography>

        <Typography variant="body2" color="text.secondary">
          Cliquez pour importer
        </Typography>

        <input
          ref={inputRef}
          hidden
          type="file"
          multiple
          onChange={(e) => handleUpload(e.target.files)}
        />

      </Box>

      {/* GRID */}

      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "repeat(3,1fr)",
          gap: 2,
          mt: 2
        }}
      >

        {photos.map((photo, index) => (

          <motion.div
            key={photo}
            whileHover={{ scale: 1.03 }}
            style={{
              position: "relative",
              borderRadius: 10,
              overflow: "hidden"
            }}
          >

            <img
              src={photo}
              style={{
                width: "100%",
                height: 110,
                objectFit: "cover"
              }}
            />

            {/* ⭐ main photo badge */}

            {index === 0 && (

              <Box
                sx={{
                  position: "absolute",
                  top: 8,
                  left: 8,
                  background: "#6366f1",
                  color: "white",
                  px: 1,
                  py: 0.3,
                  fontSize: 12,
                  borderRadius: 1
                }}
              >

                ⭐ Principale

              </Box>

            )}

            {/* actions */}

            <Box
              sx={{
                position: "absolute",
                bottom: 5,
                left: 5,
                right: 5,
                display: "flex",
                justifyContent: "space-between"
              }}
            >

              {index !== 0 && (

                <Box
                  onClick={() => setAsMain(photo)}
                  sx={{
                    background: "rgba(0,0,0,0.6)",
                    color: "white",
                    px: 1,
                    fontSize: 12,
                    borderRadius: 1,
                    cursor: "pointer"
                  }}
                >
                  Définir principale
                </Box>

              )}

              <Box
                onClick={() => handleDelete(photo)}
                sx={{
                  background: "rgba(0,0,0,0.6)",
                  color: "white",
                  width: 24,
                  height: 24,
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: 13,
                  cursor: "pointer"
                }}
              >
                ✕
              </Box>

            </Box>

          </motion.div>

        ))}

      </Box>

    </Box>
  );
}